import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { ICell } from '../../viewmodels/runnableLookups/icell';
export class LookupCell implements ViewModel, ICell {
  readonly friendlyTypeNameSingular = 'Lookup Cell';
  readonly apiRoute: string = CONFIG.apiRoutes.lookupCells;

  lookupCellId: string;
  lookupRowId: string;
  lookupColumnId: string;
  columnIndex: number;
  value: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupCellId = data.lookupCellId;
    this.lookupRowId = data.lookupRowId;
    this.lookupColumnId = data.lookupColumnId;
    this.columnIndex = data.columnIndex;
    this.value = data.value;
  }
}
